<template>
    <!--这里是旧页面-->
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="row">
            <div class="col-sm-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">
                        <div class="row table-responsive" style="padding-bottom: 60px">

                            <el-table :expand-row-keys="expandRow" :data="rows" border style="width: 100%"
                                ref="multipleTable" row-key="id" class="rowss">
                                <el-table-column type="expand" width="50">
                                    <template slot-scope="scope">
                                        <el-form :model="scope.row" :ref="`form${scope.rowid}`" label-width="0px"
                                            class="demo-dynamic form-horizontal detailPage">
                                            <div class="ibox-content">
                                                <div class="panel-body">
                                                    <div class="form-group">
                                                        <label class="col-sm-2">
                                                            Email
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <div style="margin-bottom:20px"
                                                                v-for="(emailItem, emailIndex) in scope.row.feedbackEmailList"
                                                                :key="emailIndex">
                                                                <el-form-item
                                                                    :prop="'feedbackEmailList.' + emailIndex + '.email'"
                                                                    :rules="{
                                                                        type: 'email',
                                                                        message: 'Please input the correct email address',
                                                                        trigger: ['blur', 'change']
                                                                    }">
                                                                    <el-input v-model="emailItem.email" name="search"
                                                                        clearable></el-input>
                                                                </el-form-item>

                                                            </div>
                                                        </div>
                                                        <div class="col-sm-2"
                                                            style="padding-right:0 !important;display: flex;justify-content: flex-end;">
                                                            <el-button type="warning" size="mini"
                                                                @click="handleAddEmail(scope.row.feedbackEmailList)">
                                                                Add
                                                            </el-button>
                                                            <el-button type="primary" size="mini"
                                                                @click="checkEvent(scope.row, `form${scope.rowid}`)">
                                                                Save
                                                            </el-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-form>



                                    </template>
                                </el-table-column>
                                <el-table-column width="210" sortable prop="districtNameEn"
                                    label="District Name"></el-table-column>
                                <el-table-column sortable prop="feedbackEmail" label="Email Address"></el-table-column>
                                <el-table-column label="Action" width="120">
                                    <template slot-scope="scope">
                                        <el-button type="primary" style="
                                            background-color: #409eff;
                                            border-color: #409eff;
                                            width: 95px;" size="mini" @click="handleToOpenExpandRow(scope.row)">
                                            Edit
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import config from "../config";

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            rows: [],
            expandRow: []
        };
    },
    computed: {
        userInfo() {
            return this.getAuthObj();
        },
        baseURL() {
            return config.domain + "/";
        },
        userRole() {
            const res = JSON.parse(sessionStorage.getItem("userInfo"));
            return res.roleType;
        },
    },
    created() { },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            let obj = this.getAuthObj();
            obj.apiUrl = this.apiConfig.memberCommentBoxDistrictEmailList;
            let data = await this.$store.dispatch("apiEvent", obj);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            data.data.result = data.data.result.map(i => {
                const feedbackEmailList = i.feedbackEmail ? i.feedbackEmail.split(',').map(iten => {
                    return { email: iten }
                }) : [{ email: '' }]
                return {
                    ...i,
                    feedbackEmailList
                }
            })

            this.$set(this, "rows", data.data.result);
            this.$forceUpdate()
        },
        handleToOpenExpandRow(row) {
            let rowIndex = null
            const isExist = this.expandRow.find((i, index) => {
                rowIndex = index
                return i == row.id
            })
            if (isExist) {
                this.expandRow.splice(rowIndex, 1)
            } else {
                row.feedbackEmailList = row.feedbackEmail ? row.feedbackEmail.split(',').map(iten => {
                    return { email: iten }
                }) : [{ email: '' }]
                this.expandRow.push(row.id)
            }
        },
        handleAddEmail(list) {
            list.push({ email: '' })
            this.$forceUpdate()
        },
        checkEvent: function (row, formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.handleSave(row);
                } else {
                    this.$toastr.w(this.$i18n.t("message.fillRequired"));
                    return false;
                }
            });
        },
        async handleSave(row) {
            try {
                let paramEamil = ''
                const list = row.feedbackEmailList.filter(i => {
                    return i.email
                })
                console.log("1111", list)
                list.forEach((i, index) => {
                    if (index == list.length - 1) paramEamil += i.email
                    else paramEamil += `${i.email},`
                })
                console.log("2222", paramEamil)
                let obj = this.getAuthObj();
                obj.id = row.id
                obj.feedBackEmails = paramEamil
                obj.apiUrl = this.apiConfig.memberCommentBoxDistrictEmailUpdate;
                const data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;

                if (data.data.result) {
                    this.expandRow = []
                    this.init()
                }
            } catch (err) { console.log("err:", err) }
        }
    },
};
</script>
<style lang="scss" scoped>
.search-area-bottom {
    padding: 10px 0 3px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
</style>
  